
import {
    reportTemplateSetting
} from 'redevConfig'


const add = (reportTemplateSetting && reportTemplateSetting.add) || ''
const edit = (reportTemplateSetting && reportTemplateSetting.edit) || ''
const list = (reportTemplateSetting && reportTemplateSetting.list) || ''
const preview = (reportTemplateSetting && reportTemplateSetting.preview) || ''

const listPage = list ? require(`redevelopment/system/reportTemplateSetting/${list.templateName}`) : require('./view/reportTemplateSetting.html')
const reportTemplateAdd = add ? require(`redevelopment/system/reportTemplateSetting/${add.templateName}`) : require('./view/reportTemplateAdd.html')
const reportTemplateEdit = edit ? require(`redevelopment/system/reportTemplateSetting/${edit.templateName}`) : require('./view/reportTemplateEdit.html')
const reportTemplatePreview = preview ? require(`redevelopment/system/reportTemplateSetting/${preview.templateName}`) : require('./view/reportTemplatePreview.html')

export default {
    base: {
        state: 'system.settingcenter.reportTemplateSetting',
        config: {
            url: '/reportTemplateSetting',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'system.settingcenter.reportTemplateSetting.list',
            title: '报表模板',
        },
    },
    list: {
        state: 'system.settingcenter.reportTemplateSetting.list',
        config: {
            url: '/list',
            template: listPage,
            controller: 'reportTemplateSettingCtrl',
            title: '报表模版',
        },
    },
    add: {
        state: 'system.settingcenter.reportTemplateSetting.add',
        config: {
            url: '/add',
            template: reportTemplateAdd,
            controller: 'reportTemplateAddCtrl',
            title: '新增',
        },
    },
    preview: {
        state: 'system.settingcenter.reportTemplateSetting.preview',
        config: {
            url: '/preview',
            params: { id: null },
            template: reportTemplatePreview,
            controller: 'reportTemplatePreviewCtrl',
            title: '预览',
        },
    },
    edit: {
        state: 'system.settingcenter.reportTemplateSetting.edit',
        config: {
            url: '/edit',
            params: { id: null },
            template: reportTemplateEdit,
            controller: 'reportTemplateEditCtrl',
            title: '编辑',
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/reportTemplateSetting/routers.js